import { useState } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Dialog } from '@/components/ui/dialog'
import { $chatterLanguage } from '@/models/chattingUI/messages/translations.ts'
import TutorialENDark from '@/modules/chatting/icons/translation-tutorial-en-dark.webp'
import TutorialEN from '@/modules/chatting/icons/translation-tutorial-en.webp'
import { useChats } from '@/modules/chatting/state/chats-provider'
import { useIsDarkTheme } from '@/utils/useTheme'

export const TranslationTutorial = () => {
  const chatterLanguage = useUnit($chatterLanguage)
  const { isTranslationTutorialOpen, closeTranslationTutorial } = useChats()
  const [markAsViewed, setMarkAsViewed] = useState(false)
  const isDark = useIsDarkTheme()

  if (!chatterLanguage) {
    return null
  }

  const handleClickGotIt = () => {
    closeTranslationTutorial(markAsViewed)
  }

  const handleChangeMarkAsViewed = (checked: boolean) => {
    setMarkAsViewed(checked)
  }

  return (
    <Dialog
      bigDialog
      show={isTranslationTutorialOpen}
      onClose={() => closeTranslationTutorial(false)}
      showCloseIcon={false}
      panelClassName="lg:max-w-[700px] sm:p-8"
    >
      <div className="space-y-6">
        <Dialog.Header>
          <Dialog.Title>Here is how it works</Dialog.Title>
          <Dialog.Description className="text-center">
            The messages sent by the fan will be translated into your language.
            It will also translate the messages you write into the language that
            the fan speaks.
          </Dialog.Description>
        </Dialog.Header>
        <img
          className="nsfw-ignore max-w-full"
          src={isDark ? TutorialENDark : TutorialEN}
          alt="Translation Tutorial"
        />
        <Dialog.Footer className="sm:justify-between">
          <div className="flex items-center gap-2">
            <Checkbox
              checked={markAsViewed}
              onCheckedChange={handleChangeMarkAsViewed}
            />
            <span>Don&apos;t show this again</span>
          </div>
          <Button
            className="w-1/2"
            onClick={handleClickGotIt}
          >
            Got it
          </Button>
        </Dialog.Footer>
      </div>
    </Dialog>
  )
}
